<template>
  <section>
    <div v-show="(startIndex<=1) || (endIndex>5 && startIndex==endIndex-5)">
      <hr>
      <div class="gaiyo-major-title">【2.中間検査】</div>
    </div>
    <div v-for="(c, index) in chukan"
      :key="`A-${index}`">
      <div v-show="index>=startIndex && index<endIndex">
        <div class="gaiyo-row">
          <!--
          <div class="shobun-element left-02">({{c.seQ_NO}})</div>
          -->
          <div class="shobun-element left-02">({{index+1}})</div>
          <div class="shobun-minor-title left-08">
            【ｲ.特定工程】
          </div>
          <div class="shobun-element left-55">{{c.tokuteI_NAME}}</div>
          <div class="gaiyo-row">
            <div v-for="(n,index) in wordwrap(c.tokuteI_NAME,40)" :key="`tokutei-name-${index}`">
              <br v-show="index>0"></div>
          </div>
        </div>
        <div class="gaiyo-row">
          <div class="shobun-minor-title left-08">
            【ﾛ.検査日】
          </div>
          <div class="shobun-element left-55">{{dateTextToWareki(c.kensA_DAY)}}</div>
        </div>
        <div class="gaiyo-row">
          <div class="shobun-minor-title left-08">
            【ﾊ.中間検査合格証交付者】
          </div>
          <div class="shobun-element left-55">{{c.dlvrer}}</div>
        </div>
        <div class="gaiyo-row">
          <div class="shobun-minor-title left-08">
            【ﾆ.中間検査合格証番号】
          </div>
          <div class="shobun-element left-55 shobun-no">{{c.kknN_NO}}</div>
          <div class="shobun-element left-125">【ﾎ.交付年月日】</div>
          <div class="shobun-element left-155">{{dateTextToWareki(c.kknN_DAY)}}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { dateTextToWareki } from '../../common/utils'

export default {
  props: {
    chukan: {
      type: Array,
      default: () => [],
    },
    startIndex: {
      type: Number,
      default: () => 0
    },
    endIndex: {
      type: Number,
      default: () => 99
    }
  },
  methods: {
    /**
     * 日付の和暦変換
     * @param {Date} date 変換する日付
     * @return {String} 和暦表現に変換された文字列を返す
     */
    dateTextToWareki(date) {
      return dateTextToWareki(date);  // from utils.js
    },
    wordwrap(text, len) {
      let result = [];
      if (text && text.length) {
        let start = 0;
        for (let i = 0; i < text.length; i += len) {
          result.push(text.substr(start, len));
          start += len;
        }
      }
      return result;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/gaiyo.css";

</style>